/**
 * Tema compartido del panel de administración.
 * Importar en vistas: import theme from '../adminTheme';
 */

const primary = '#1a4d8c';
const danger = '#c62828';
const success = '#2e7d32';

export default {
  // Contenedores
  container: {
    background: '#fff',
    padding: 24,
    borderRadius: 12,
    maxWidth: 1200,
    boxShadow: '0 2px 10px rgba(0,0,0,0.06)'
  },

  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
    flexWrap: 'wrap',
    gap: 16
  },

  title: {
    margin: 0,
    fontSize: 26,
    fontWeight: 700,
    color: '#1a1a1a'
  },

  subtitle: {
    color: '#666',
    marginTop: 6,
    marginBottom: 0,
    fontSize: 15
  },

  // Búsqueda
  searchContainer: {
    display: 'flex',
    gap: 12,
    alignItems: 'center',
    flex: 1,
    maxWidth: 400
  },

  searchInput: {
    flex: 1,
    padding: '10px 14px',
    border: '1px solid #ddd',
    borderRadius: 8,
    fontSize: 14
  },

  // Botones
  btnPrimary: {
    padding: '8px 14px',
    background: primary,
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: 600
  },

  btnGhost: {
    padding: '8px 14px',
    background: '#f4f6f8',
    color: '#111',
    border: '1px solid #ddd',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: 600,
    marginRight: 8
  },

  btnSecondary: {
    padding: '8px 14px',
    background: '#f4f6f8',
    color: '#111',
    border: '1px solid #ddd',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: 600,
    marginRight: 8
  },

  btnDanger: {
    padding: '8px 14px',
    background: danger,
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: 600
  },

  btnRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8,
    flexWrap: 'wrap'
  },

  // Tabla
  table: {
    width: '100%',
    borderCollapse: 'collapse'
  },

  th: {
    padding: '12px',
    textAlign: 'left',
    fontSize: 13,
    color: '#555',
    borderBottom: '1px solid #e0e0e0'
  },

  td: {
    padding: '12px',
    fontSize: 14,
    borderBottom: '1px solid #f0f0f0'
  },

  // Card
  card: {
    background: '#fff',
    borderRadius: 12,
    padding: 16,
    boxShadow: '0 2px 10px rgba(0,0,0,0.06)'
  },

  // Badges base
  badge: {
    padding: '4px 10px',
    borderRadius: 12,
    fontSize: 12,
    fontWeight: 600,
    textTransform: 'capitalize'
  },

  badgeActivo: { background: '#dcfce7', color: '#166534' },
  badgeInactivo: { background: '#fef3c7', color: '#92400e' },
  badgeSuspendido: { background: '#fee2e2', color: '#991b1b' },

  // Mensajes
  error: {
    color: danger,
    padding: '12px',
    background: '#ffebee',
    borderRadius: '8px',
    marginBottom: 16
  },

  success: {
    color: success,
    padding: '12px',
    background: '#e8f5e9',
    borderRadius: '8px',
    marginBottom: 16
  },

  loading: {
    textAlign: 'center',
    padding: '48px 24px',
    color: '#666'
  },

  empty: {
    textAlign: 'center',
    padding: '24px',
    color: '#666'
  },

  // Paginación
  pagination: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 20,
    padding: '12px 0',
    borderTop: '1px solid #eee',
    flexWrap: 'wrap',
    gap: 12
  },

  paginationInfo: {
    color: '#666',
    fontSize: 14
  },

  paginationButtons: {
    display: 'flex',
    gap: 8
  },

  btnPagination: {
    background: '#fff',
    color: primary,
    border: `1px solid ${primary}`,
    padding: '8px 16px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: 13,
    fontWeight: 500
  },

  btnPaginationDisabled: {
    background: '#f5f5f5',
    color: '#999',
    border: '1px solid #ddd',
    padding: '8px 16px',
    borderRadius: '8px',
    cursor: 'not-allowed',
    fontSize: 13
  },

  // Modal (referencia; usar componente AdminModal)
  modalOverlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.45)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000
  },

  modal: {
    background: '#fff',
    borderRadius: 12,
    width: '100%',
    maxWidth: 480,
    padding: 24,
    maxHeight: '90vh',
    overflow: 'auto'
  },

  modalTitle: {
    fontSize: 20,
    fontWeight: 600,
    marginBottom: 20
  },

  modalRow: { marginBottom: 10, fontSize: 14 },
  modalLabel: { fontWeight: 600, color: '#374151' },

  formGroup: { marginBottom: 16 },
  label: { display: 'block', marginBottom: 6, fontWeight: 500, color: '#333' },
  input: {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #ddd',
    borderRadius: 8,
    fontSize: 14,
    boxSizing: 'border-box'
  },
  select: {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #ddd',
    borderRadius: 8,
    fontSize: 14,
    boxSizing: 'border-box',
    background: '#fff'
  },
  textarea: {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #ddd',
    borderRadius: 8,
    fontSize: 14,
    boxSizing: 'border-box',
    minHeight: 80,
    resize: 'vertical'
  },
  modalActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 12,
    marginTop: 24
  },

  // Breadcrumb
  breadcrumb: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 16,
    fontSize: 14,
    color: '#666'
  },
  breadcrumbLink: {
    color: primary,
    cursor: 'pointer',
    textDecoration: 'none'
  },
  breadcrumbSep: { color: '#999' },
  breadcrumbCurrent: { color: '#333', fontWeight: 500 }
};
